module.exports = __webpack_public_path__ + "img/durban-super-giants-logo-icon.c8795e23.png";